import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

export default function MusikSuchenResultsControlsContainer({ children }) {
  return (
    <Grid item xs={6} sm={7}>
      <Grid
        container
        justifyContent="flex-end"
        alignItems="flex-end"
        sx={{ height: "100%" }}
      >
        <Grid item>
          <Stack direction="row" spacing={{ sm: 0.5 }}>
            {children}
          </Stack>
        </Grid>
      </Grid>
    </Grid>
  );
}
